'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCrop54 = function ImageCrop54(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' })
  );
};
ImageCrop54 = (0, _pure2.default)(ImageCrop54);
ImageCrop54.displayName = 'ImageCrop54';
ImageCrop54.muiName = 'SvgIcon';

exports.default = ImageCrop54;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/crop-5-4.js
// module id = 1520
// module chunks = 0